var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcluir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.093,
    height: 16.833,
    viewBox: "0 0 13.093 16.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M5.935,17.963a1.876,1.876,0,0,0,1.87,1.87h7.482a1.876,1.876,0,0,0,1.87-1.87V6.741H5.935ZM18.093,3.935H14.82L13.884,3H9.208l-.935.935H5v1.87H18.093Z",
    transform: "translate(-5 -3)",
    fill: "#2d2d2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcluir);
export default __webpack_public_path__ + "static/media/excluir.88f19a76146f577acc03f14bddc988e7.svg";
export { ForwardRef as ReactComponent };